import { useState } from 'react';
import ConfirmModal from '../Modal/ConfirmModal';

const Button = ({
	type = 'button',
	value,
	form,
	className,
	onClick,
	onConfirm,
	isLoading,
	loadingMessage,
	children,
	disabled,
	style
}) => {
	const [showConfirm, setShowConfirm] = useState(false);

	const handleClick = () => {
		if (onConfirm) {
			setShowConfirm(true);
		} else {
			if (onClick) onClick();
		}
	};

	const handleConfirm = () => {
		if (onConfirm) onConfirm();
		setShowConfirm(false);
	};

	return (
		<>
			<button 
				type={type} 
				className={className} 
				form={form} 
				onClick={handleClick}
				disabled={disabled || isLoading}
				style={style}
			>
				{isLoading ? (
	              <>
	                <span className="spinner-border spinner-border-sm me-3" />
	                {loadingMessage}
	              </>
	            ) : (
	              <>{children}</>
	            )}
			</button>

			{onConfirm && (
				<ConfirmModal
					id="confirm-action"
					show={showConfirm}
					onClose={() => setShowConfirm(false)}
					title="Do you confirm this action?"
					onConfirm={handleConfirm}
				/>
			)}
		</>
	);
};

export default Button;
